import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { fetchChatTopics, fetchCoachAvailability } from "actions/chat";
import moment from "moment";
import useTranslate from "hooks/use-translate-language";
import { useDispatch } from "react-redux";
import { convertTimeFromCSTToBrowserTz } from "utils/misc";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Page } from "components/ui";
import { Breadcrumbs, Button } from "components/ui_new";

import ChooseTopic from "./choose-topic";
import ChooseDate from "./choose-date";
import ChooseSlot from "./choose-slot";
import "./schedule-chat.scss";

const TimeSlotSearchForm = ({ handleTimeSlotSelect }) => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [topicCategory, setTopicCategory] = useState("");

  useEffect(() => {
    dispatch(fetchChatTopics());
  }, [dispatch]);
  const [availableSlotsResults, setAvailableTimeSlotsResult] = useState(null);
  const [date, setSelectedDate] = useState(moment());
  const [description, setDescription] = useState("");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState();

  const extractTimesAndCoachIdFromTimeSlot = selectedTimeSlot => {
    const coachId = selectedTimeSlot.substring(
      0,
      selectedTimeSlot.indexOf("_")
    );
    const start_time = selectedTimeSlot.substring(
      selectedTimeSlot.indexOf("_") + 1,
      selectedTimeSlot.indexOf("/")
    );
    const end_time = selectedTimeSlot.substring(
      selectedTimeSlot.indexOf("/") + 1
    );
    return { coachId, start_time, end_time };
  };

  const fetchTimestlos = () => {
    if (topicCategory == "") return;

    setIsFetching(true);

    dispatch(
      fetchCoachAvailability({ date, appointment_topic_id: topicCategory })
    )
      .then(result => {
        if (result.success) {
          result = {
            ...result,
            slots: result.slots.map(slot => ({
              ...slot,
              AvailabilitySlotsTimes: slot.AvailabilitySlotsTimes.map(
                availability => ({
                  ...availability,
                  Start: convertTimeFromCSTToBrowserTz(availability.Start),
                  End: convertTimeFromCSTToBrowserTz(availability.End)
                })
              )
            }))
          };
          setAvailableTimeSlotsResult(result);
        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  const submit = async () => {
    try {
      setIsFetching(true);
      const { coachId, start_time, end_time } =
        extractTimesAndCoachIdFromTimeSlot(selectedTimeSlot);

      await handleTimeSlotSelect({
        topic_category_id: topicCategory,
        date: moment(date).format("YYYY-MM-DD") + "T00:00:00",
        description: description,
        startTime: start_time,
        endTime: end_time,
        coachId: coachId
      });
    } finally {
      setIsFetching(false);
    }
  };

  const steps = [
    translate("chooseATopic"),
    translate("date"),
    translate("chooseWith")
  ];
  return (
    <Page.Content isFetching={isFetching}>
      <div style={{ marginLeft: "2%" }}>
        <Breadcrumbs
          childLabel="scheduleNew"
          parentLink=""
          parentLinkLabel="appointments"
          title="scheduleAMeeting"
        />
        <Box>
          <Stepper
            activeStep={step}
            aria-label={`Schedule appointment progress, step ${step + 1} of ${steps.length}`}
          >
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {step == 0 && (
            <ChooseTopic
              topicCategory={topicCategory}
              setTopicCategory={setTopicCategory}
            />
          )}
          {step == 1 && (
            <ChooseDate date={date} setSelectedDate={setSelectedDate} />
          )}
          {step == 2 && (
            <ChooseSlot
              isFetching={isFetching}
              timeslots={availableSlotsResults?.slots ?? []}
              description={description}
              setDescription={setDescription}
              selectedTimeSlot={selectedTimeSlot}
              setSelectedTimeSlot={setSelectedTimeSlot}
            />
          )}
          <div className="buttons-container">
            <div
              className={`${step == 0 ? "left" : "j-around"}`}
              style={{ width: "100%" }}
            >
              {step > 0 && (
                <Button
                  className="btn"
                  onClick={() => {
                    setStep(step - 1);
                  }}
                  variant="outlined"
                >
                  {translate("back")}
                </Button>
              )}
              <Button
                className="btn"
                onClick={async () => {
                  if (step + 1 == 2 && topicCategory && date) {
                    fetchTimestlos();
                  }

                  if (step == 2) {
                    await submit();
                  } else setStep(step + 1);
                }}
                variant="contained"
                disabled={
                  (step == 0 && !topicCategory) ||
                  (step == 2 && !selectedTimeSlot)
                }
              >
                {step == 2 ? translate("submit") : translate("next")}
              </Button>
            </div>
          </div>
        </Box>
      </div>
    </Page.Content>
  );
};

TimeSlotSearchForm.propTypes = {
  handleTimeSlotSelect: PropTypes.func.isRequired,
  chat_type: PropTypes.number,
  formControlStyle: PropTypes.object
};

TimeSlotSearchForm.defaultProps = {
  chat_type: 1,
  formControlStyle: {}
};

export default TimeSlotSearchForm;
